import Rfc5322EmailHelper from "./rfc5322EmailHelper";

export default class VerifiableEmailHelper {
    /**
     * This method builds on RFC5322 format validation and additionally requires
     * a dotted domain name with a TLD.
     * @param {string} emailAddress
     * @returns {boolean}
     */
    isFormatValid(emailAddress) {
        const rfc5322EmailHelper = new Rfc5322EmailHelper();

        if (!rfc5322EmailHelper.isValidFormat(emailAddress)) {
            return false;
        }

        const domain = rfc5322EmailHelper.extractDomain(emailAddress);
        return this._domainHasTld(domain);
    }

    _domainHasTld(domain) {
        if (!domain) {
            return false;
        }

        if (domain.startsWith("[") && domain.endsWith("]")) {
            return false;
        }

        const normalizedDomain = domain.replace(/\(.*?\)/g, "");
        const labels = normalizedDomain.split(".").filter(Boolean);

        return labels.length >= 2;
    }
}